import React from 'react'
import LoginFormView from './LoginFormView';
import userStore from 'stores/userStore'

const LoginForm = () => (
    <LoginFormView authLogin={userStore.authLogin} />
)

export default LoginForm
